var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex align-center"},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-format-quote-close")]),_c('h3',{staticClass:"mb-0 font-weight-regular text-decoration-underline",staticStyle:{"text-underline-position":"under"}},[_vm._v(" Quote Master ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }